import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  wrapper: {
    display: 'none',
  },
 
  
  form: {
    height: 'inherit'
  }
}));

export default useStyles;
